import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import airforce from "./Airforce Crest.png";
import army from "./Army_logo.png";
import navy from "./Navy-crest.png";
import Header from "./Header";
import PropTypes from "prop-types";
import nttlogo from "./nttlogo.png";
import Certificate from "./certificate";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${date.getFullYear()}`;
};

const FeeReceiptUI = ({ receiptData, isLoading, sendEReceipt }) => {
  //console.log("FeeReceiptUI Rendered");
  const navigate = useNavigate();

  const pancard = sessionStorage.getItem("pancard");

  useEffect(() => {
    if (sendEReceipt && receiptData?.email && receiptData?.transaction_id) {
      sendEReceipt(receiptData);
    }
  }, [receiptData, sendEReceipt]);

  const handleDownload = async () => {
    if (!receiptData) {
      alert("Error: Receipt data is not available. Please try again later.");
      return;
    }

    const receiptElement = document.querySelector(".receipt-container");
    if (!receiptElement) {
      alert("Error: Unable to generate PDF. Receipt container not found.");
      return;
    }

    try {
      const images = receiptElement.querySelectorAll("img");
      const loadPromises = Array.from(images).map((img) =>
        img.complete
          ? Promise.resolve()
          : new Promise((resolve) => {
              img.onload = resolve;
              img.onerror = () => resolve();
            })
      );
      await Promise.all(loadPromises);

      // Add a short delay to ensure any pending rendering or image stabilization
      await new Promise((resolve) => setTimeout(resolve, 200));

      const canvas = await html2canvas(receiptElement, {
        scale: 3,
        useCORS: true,
        allowTaint: true,
        logging: false,
      });

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const imgWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = pdf.internal.pageSize.getHeight(); // force fit to one page

      pdf.addImage(
        canvas.toDataURL("image/png", 1.0),
        "PNG",
        0,
        0,
        imgWidth,
        imgHeight
      );

      const filename = `${receiptData.transaction_id || "receipt"}_Receipt.pdf`;
      pdf.save(filename);
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Error: Failed to generate PDF. Please try again.");
    }
  };

const handleDownloadCertificate = async () => {
  const certificateElement = document.getElementById("certificate-pdf");
  if (!certificateElement) {
    alert("Certificate element not found.");
    return;
  }

  // Wait for all images to load
  const images = certificateElement.querySelectorAll("img");
  const loadPromises = Array.from(images).map((img) =>
    img.complete
      ? Promise.resolve()
      : new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        })
  );
  await Promise.all(loadPromises);

  // Small delay to ensure rendering is stable
  await new Promise((res) => setTimeout(res, 200));

  try {
    const canvas = await html2canvas(certificateElement, {
      scale: 2,
      useCORS: true,
      allowTaint: false,
    });

    // Double-check canvas size
    if (!canvas.width || !canvas.height) {
      throw new Error("Canvas has invalid dimensions.");
    }

    const imgData = canvas.toDataURL("image/jpeg", 1.0);

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // Scale image to fit page while keeping aspect ratio
// Scale image to fit page while keeping aspect ratio
const ratio = Math.min(pageWidth / canvas.width, pageHeight / canvas.height);

// Apply a zoom-out factor (e.g. 0.9 = 90% of max size)
const zoomOutFactor = 0.9;

const imgWidth = canvas.width * ratio * zoomOutFactor;
const imgHeight = canvas.height * ratio * zoomOutFactor;

// Center the image on the page
const x = (pageWidth - imgWidth) / 2;
const y = (pageHeight - imgHeight) / 2;

pdf.addImage(imgData, "JPEG", x, y, imgWidth, imgHeight);

        const filename = `${receiptData.transaction_id || "receipt"}_Certificate.pdf`;
      pdf.save(filename);
  } catch (error) {
    console.error("Error generating certificate PDF:", error);
    alert("Failed to generate certificate PDF. Please try again.");
  }
};


  const tableData = [
    { label: "Name", value: receiptData?.donor_name || "N/A" },
    { label: "Email", value: receiptData?.email || "N/A" },
    { label: "Phone Number", value: receiptData?.mobile_number || "N/A" },
    { label: "Transaction ID", value: receiptData?.transaction_id || "N/A" },
    { label: "Date", value: formatDate(receiptData?.added_on || "N/A") },
    {
      label: "PAN Number",
      value: pancard
        ? pancard
        : Number(receiptData?.pancard_flag) === 1
        ? "Yes"
        : "No",
    },
    {
      label: "Amount Paid",
      value: receiptData?.transaction_amount
        ? `₹ ${Number(receiptData.transaction_amount).toFixed(2)}`
        : "N/A",
    },
  ];

  return (
    <>
      <div>
        {isLoading ? (
          <p>Loading...</p>
        ) : receiptData ? (
          <div className="receipt-container">
            <div className="watermark"></div>

            <div className="header-fee">
              <Header />
              <div className="logo-container">
                <div className="additional-logos">
                  <img
                    src={army}
                    alt="Indian Army Crest"
                    className="army-logo"
                  />
                  <img
                    src={navy}
                    alt="Indian Navy Crest"
                    className="navy-logo"
                  />
                  <img
                    src={airforce}
                    alt="Indian Air Force Crest"
                    className="airforce-logo"
                  />
                </div>
              </div>
            </div>

            <h2 className="title">Receipt</h2>
            <h2 className="title-armedforces">
              Armed Forces Battle Casualties Welfare Fund
            </h2>

            <table className="receipt-table">
              <tbody>
                {tableData.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <strong>{item.label}</strong>
                    </td>
                    <td>{item.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <p className="footer-note">
              Thank you for your valuable contribution towards the welfare of
              Armed Forces personnel and their families.
            </p>
            <div className="receipt-poweredby">
              <span className="receipt-poweredby-text">powered by</span>
              <img
                src="https://payformservices.nttdatapay.com/logos/armedforces/adaptis-dark.webp"
                alt="NTT Data Pay Logo"
                className="receipt-poweredby-logo"
              />
            </div>
          </div>
        ) : (
          <p>No receipt data available.</p>
        )}
      </div>

      {!isLoading && receiptData && (
        <>
          <div className="button-container">
            <button className="action-btn" onClick={handleDownload}>
              Download PDF
            </button>
            <button className="action-btn" onClick={handleDownloadCertificate}>
              Download certificate
            </button>
          </div>

          {/* Hidden Certificate for PDF generation */}
        <div style={{ position: "absolute", left: "-9999px", top: 0 }}>

            <Certificate receiptData={receiptData} formatDate={formatDate}/>
          </div>
        </>
      )}
    </>
  );
};

FeeReceiptUI.propTypes = {
  receiptData: PropTypes.shape({
    transaction_id: PropTypes.string,
    donor_name: PropTypes.string,
    mobile_number: PropTypes.string,
    email: PropTypes.string,
    pancard_flag: PropTypes.string,
    transaction_amount: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    added_on: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
    ]),
  }),
  isLoading: PropTypes.bool.isRequired,
  sendEReceipt: PropTypes.func,
};

export default FeeReceiptUI;

